document.addEventListener("DOMContentLoaded", function () {
    let a = document.querySelector('.cart__checkout-button')
    if (a) {
        a.classList.add('bss-disable')
    }
    setTimeout(() => {
         a.classList.remove('bss-disable')
    }, 4000);
});